import React from "react";
import Div from "../Div";
import "./logolist.scss";

export default function LogoList() {
  const partnerLogos = [
    {
      src: "/images/pics/maniac-line.jpg",
      alt: "Partner",
    },
    {
      src: "/images/pics/adams.jpg",
      alt: "Partner",
    },
    {
      src: "/images/pics/gyeon.jpg",
      alt: "Partner",
    },
    {
      src: "/images/pics/chemical-guys.jpg",
      alt: "Partner",
    },
    {
      src: "/images/pics/meguiars.jpg",
      alt: "Partner",
    },
  ];
  return (
    <Div className="cs-partner_logo_wrap">
      {partnerLogos.map((partnerLogo, index) => (
        <div className="cs-partner_logo" key={index}>
          <img src={partnerLogo.src} alt={partnerLogo.alt} />
        </div>
      ))}
    </Div>
  );
}
